
function refreshToken(navigator) {
  const prev_tokenSetTime = localStorage.getItem("tokenSetTime");
  const date = new Date();
  let time = date.getTime();

  // console.log('prev time is  ' + prev_tokenSetTime);
  // console.log('time is   ' + time);
  if (+prev_tokenSetTime + +(57 * 60 * 1000) < time) {
    const prev_token = localStorage.getItem("token");
    // console.log(prev_token);

    //refresh token from http 
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer "+prev_token );
    
    var raw = "";
    
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };
    
    fetch("https://negar-khodro.com/api/Refresh", requestOptions)
        .then(response => response.text())
        .then(result => {// console.log(result);
        const resObj =JSON.parse(result);
          console.log('refreshToken : ' +resObj);
          localStorage.removeItem("token");
          localStorage.removeItem("tokenSetTime");
          localStorage.setItem("token", resObj.token);
          localStorage.setItem("tokenSetTime" , time); 
        })
        .catch(error => { 
          navigator("/login");
          console.log('refresh token error', error)});

  } else {
    // console.log("no need to change jwt token!");
  }
}
export default refreshToken;
 